import * as rest from './RestUtil';
import { getFunctionBaseUrl } from './RestUrls';
import { IMailTemplateDetails } from '../util/DataModelInterface';
import * as storage from '../util/StorageUtil';

export const getMessages = async (force: boolean = false) => {
  let messages = storage.getMessages();
  if (!messages || force) {
    const url = `${getFunctionBaseUrl()}/api/getMessages`;
    const response = await rest.get(url);
    if(response && response.result) {
      storage.setMessages(response.result);
      messages = response.result;
    } else {
      return response;
    }
  }
  return messages;
}

export const modifyMessage = async (message: IMailTemplateDetails) => {
  const url = `${getFunctionBaseUrl()}/api/modifyMessage/`;
  const response = await rest.post(url, message);
  // console.log("resp: ", response);
  return response;
}
